import React, { forwardRef, useEffect, useRef, useState } from "react";
import VisibilityModal from "../modals/VisibilityModal";
import ToolbarButton, { ToolbarButtonProps } from "../ToolbarButton";

interface VisibilityButtonPropsSimple extends ToolbarButtonProps {
  active?: boolean;
  onPositionUpdate: (rect: DOMRect) => void;
}

const VisibilityButton = forwardRef<HTMLButtonElement, VisibilityButtonPropsSimple>(
  ({ tooltip, icon, sizes, active = false, onPositionUpdate, ...rest }, ref) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    // Expose the button DOM node via the forwarded ref.
    React.useImperativeHandle(ref, () => buttonRef.current!);

    const updatePosition = () => {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        onPositionUpdate(rect);
      }
    };

    const handleClick = () => {
      setModalOpen((prev) => !prev);
    };

    useEffect(() => {
      if (isModalOpen && buttonRef.current) {
        updatePosition();
      }
    }, [isModalOpen]);

    return (
      <>
        <ToolbarButton
          {...rest}
          ref={buttonRef}
          tooltip={tooltip}
          icon={icon}
          onClick={handleClick}
          sizes={sizes}
          active={isModalOpen || active}
        />
        <VisibilityModal
          open={isModalOpen}
          onClose={() => setModalOpen(false)}
          sizes={sizes}
          buttonPosition={buttonRef.current?.getBoundingClientRect()}
        />
      </>
    );
  }
);

export default VisibilityButton;
